<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { DiscordIcon } from '../../../../assets/icons/DiscordIcon';
	import { InstagramIcon } from '../../../../assets/icons/InstagramIcon';
	import { TelegramIconLight } from '../../../../assets/icons/TelegramIconLight';
	import { TiktokIcon } from '../../../../assets/icons/TiktokIcon';
	import { TwitterXIcon } from '../../../../assets/icons/TwitterXIcon';
	import { YouTubeIcon } from '../../../../assets/icons/YouTubeIcon';
	import { IconLink } from '../../../../components/IconLink';
	import { SocialsLinks } from '../../constants/links';
	import { page } from '$app/state';

	interface Props {
		dataCy: string;
		class?: string;
		iconProps?: {
			color?: string | undefined;
			title?: string | undefined;
			class?: string;
		};
	}

	let { ...props }: Props = $props();

	let dataCyPrefix = $derived(`${props.dataCy}-socials`);
</script>

<div class={twMerge('flex', props.class)}>
	<IconLink
		dataCy={`${dataCyPrefix}-instagram`}
		label="Go to Instagram"
		href={SocialsLinks.Instagram}
		class="flex items-center"
		target="_blank"
		rel="noopener noreferrer"
	>
		<InstagramIcon color="gray-50" {...props.iconProps || {}} />
	</IconLink>

	<IconLink
		dataCy={`${dataCyPrefix}-twitter-x`}
		label="Go to X"
		href={SocialsLinks.Twitter}
		class="flex items-center"
		target="_blank"
		rel="noopener noreferrer"
	>
		<TwitterXIcon color="gray-50" {...props.iconProps} />
	</IconLink>

	<IconLink
		dataCy={`${dataCyPrefix}-discord`}
		label="Go to Discord"
		href={SocialsLinks.Discord}
		class="flex items-center"
		target="_blank"
		rel="noopener noreferrer"
	>
		<DiscordIcon color="gray-50" {...props.iconProps} />
	</IconLink>

	<IconLink
		dataCy={`${dataCyPrefix}-tiktok`}
		label="Go to TikTok"
		href={SocialsLinks.Tiktok}
		class="flex items-center"
		target="_blank"
		rel="noopener noreferrer"
	>
		<TiktokIcon color="gray-50" {...props.iconProps} />
	</IconLink>

	{#if page.url.pathname.startsWith('/news')}
		<IconLink
			dataCy={`${dataCyPrefix}-telegram`}
			label="Go to Telegram"
			href={SocialsLinks.Telegram}
			class="flex items-center translate-x-[-2px] translate-y-[1px]"
			target="_blank"
			rel="noopener noreferrer"
		>
			<TelegramIconLight color="gray-50" {...props.iconProps} />
		</IconLink>
	{/if}

	<IconLink
		dataCy={`${dataCyPrefix}-youtube`}
		label="Go to YouTube"
		href={SocialsLinks.YouTube}
		class="flex items-center"
		target="_blank"
		rel="noopener noreferrer"
	>
		<YouTubeIcon color="gray-50" {...props.iconProps} />
	</IconLink>
</div>
